import { getId } from '../helpers/file';

const USER_FEEDBACK_ENDPOINT = '/api/img-cloud/feedback';
const USER_FEEDBACK_DRAFT_KEY = 'imgcloud_user_feedback_unsent_draft';

export type UserFeedbackType = 'bug' | 'suggestion' | 'experience' | 'other';

export interface UserFeedbackDiagnostics {
  pageUrl: string;
  path: string;
  language: string;
  uid: string;
  userAgent: string;
  viewportWidth: number;
  viewportHeight: number;
  screenWidth?: number;
  screenHeight?: number;
  timezone?: string;
  timestamp: string;
}

export interface UserFeedbackPayload {
  feedbackType: UserFeedbackType;
  content: string;
  contact?: string;
  uid?: string;
  diagnostics?: UserFeedbackDiagnostics;
}

export interface UserFeedbackDraft extends UserFeedbackPayload {
  savedAt: number;
}

export interface UserFeedbackResponse {
  success: boolean;
  message?: string;
  data?: Record<string, unknown>;
}

export const collectFeedbackDiagnostics = (language: string): UserFeedbackDiagnostics => {
  const uid = getId() || '';
  const path = `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    pageUrl: window.location.href,
    path,
    language,
    uid,
    userAgent: navigator.userAgent || '',
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    screenWidth: window.screen?.width,
    screenHeight: window.screen?.height,
    timezone,
    timestamp: new Date().toISOString(),
  };
};

export const submitUserFeedback = async (payload: UserFeedbackPayload): Promise<UserFeedbackResponse> => {
  const response = await fetch(USER_FEEDBACK_ENDPOINT, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  let data: UserFeedbackResponse | null = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok || data?.success === false) {
    throw new Error(data?.message || `Feedback request failed (${response.status})`);
  }

  return data || { success: true };
};

export const saveUnsentFeedbackDraft = (payload: UserFeedbackPayload): void => {
  try {
    const draft: UserFeedbackDraft = {
      ...payload,
      savedAt: Date.now(),
    };
    localStorage.setItem(USER_FEEDBACK_DRAFT_KEY, JSON.stringify(draft));
  } catch (error) {
    console.error('保存用户反馈草稿失败:', error);
  }
};

export const getUnsentFeedbackDraft = (): UserFeedbackDraft | null => {
  try {
    const stored = localStorage.getItem(USER_FEEDBACK_DRAFT_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.error('读取用户反馈草稿失败:', error);
    return null;
  }
};

export const clearUnsentFeedbackDraft = (): void => {
  try {
    localStorage.removeItem(USER_FEEDBACK_DRAFT_KEY);
  } catch (error) {
    console.error('清理用户反馈草稿失败:', error);
  }
};
